import RecentPosts from './recentPosts';
import Categories from './categories';
import Info from './info';
import { BREAK_POINTS } from '@utils/constants';
import { useWidth } from '@utils/hooks/useWidth';

function InfoSide({ categories, socials, image, shortBio, highlights }) {
	const windowWidth = useWidth();

	return (
		<div className="column">
			{windowWidth > BREAK_POINTS.tablet && (
				<Info shortBio={shortBio} image={image} socials={socials} />
			)}

			<RecentPosts highlights={highlights} />
			<Categories categories={categories} />
		</div>
	);
}
export default InfoSide;
